import type { BulkActionOverlayAction } from '@civilgrid/ui/components';
import { useMemo, useState } from 'react';

export function useBulkActions() {
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const bulkActions: BulkActionOverlayAction[] = useMemo(
    () => [
      {
        label: 'Download Selected Documents',
        icon: 'download',
        onClick: () => setIsDownloadModalOpen(true),
        testId: 'land-rights-bulk-download-action',
      },
    ],
    [],
  );

  return {
    bulkActions,
    download: {
      isOpen: isDownloadModalOpen,
      setIsOpen: setIsDownloadModalOpen,
    },
  };
}
